import templateUrl from './report-list.html';

export const reportListComponent = {
    bindings: {
        details: '<',
        slugUrl: '@',
        menuName: '@'
    },

    templateUrl,

    controller: class ReportListComponent {
        constructor($state, ReportListService, DashboardService, DynamicMenusService, ModalService, toastr) {
            'ngInject';

            this.$state = $state;
            this.reportListService = ReportListService;
            this.dashboardService = DashboardService;
            this.dynamicMenusService = DynamicMenusService;
            this.modalService = ModalService; 
            this.toastr = toastr;
        }

        $onInit() {
            this.details = this.reportListService.getReportListObject(this.details, this.menuName);
            this.activeMenuName = this.dashboardService.getActiveMenuName();
            this.details.pageTitle = `${this.activeMenuName} List`;
        }

        onDelete(slug) {
            this.modalService.open({
                details: {
                    bodyMessage: 'Are you sure you want to delete ?'
                },
                buttons: [{
                    name: 'No'
                }, {
                    name: 'Yes',
                    isPrimary: true,
                    action: _onDelete.bind(this, slug)
                }]
            });

            function _onDelete(slug) {
                this.dynamicMenusService.deleteMenuDetailsByUrl(`${slug}/delete`)
                    .then((details) => {
                        this.toastr.success('data deleted succesfully');
                        this.$state.reload();
                    }).catch((error) => {
                        this.toastr.error(error);
                    });
            }
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/components/report-list/report-list.component.js